<template>
    <div class="full-width" v-if="null != departmentList && departmentList.length > 0">
        <div class="span-div" v-for="(value, index) in departmentList" :key="value.id">
            <el-button size="small" class="multiple-line-btn" color="#8E44AD" :plain="index !== 0" @click="clickDPBtn(value.id)">{{value.departmentname}}</el-button>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps(['departmentList'])
    const emits = defineEmits(['clickDPBtn'])

    function clickDPBtn(id) {
        emits('clickDPBtn', id)
    }

</script>

<style scoped>
    .full-width {
        width: 100%;
        text-align: left;
    }

    .multiple-line-btn {
        margin-bottom: 5px;
    }

    .span-div {
        display: inline;
        margin-left: 5px;
    }
</style>